@if (isLoading()) {
  <div class="flex h-full w-full items-center justify-center">
    <pl-loader />
  </div>
} @else {
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    @for (certificate of certificates(); track certificate.buttonId) {
      <pl-certificate
        class="flex justify-center h-full"
        [certificateName]="certificate.certificateName"
        [certificateJsonFileToGeneratePdf]="certificate.certificateJsonFileToGeneratePdf"
        [buttonTitle]="'utils.download' | translate"
        [title]="certificate.title"
        [color]="certificate.color"
        [lockedMessage]="certificate.lockedMessage"
      />
    } @empty {
      <p class="text-lg">{{ 'profile.certificates.no_certificate' | translate }}</p>
    }
  </div>
}
